import { useMongoLazyQuery, useMongoQuery } from "contexts/useMongoQuery";

export const useSearchPatient = () => {
    const [searchPatient, { called, loading, data }] = useMongoLazyQuery("patients")
    const patient = data ?? {}
    return {
        searchPatient,
        loading,
        called,
        patient
    }
}

export const usePatients = (patientId: string) => {
    const { data, loading, error } = useMongoQuery("patients", { patientId })
    const patient = data ?? {}
    return {
        loading,
        patient,
    }
}